import ReactDOM from 'react-dom';
import React from 'react';

const AEMComponentPortal = ({
  selector,
  children,
}: {
  selector: string;
  children: React.ReactNode;
}) => {
  const elem = document.querySelector(`[data-react-component=${selector}]`);

  if (elem) {
    // Only render children if mounting point is available
    return ReactDOM.createPortal(children, elem);
  }

  return null;
};

export default AEMComponentPortal;
